import React, { FormEvent } from 'react';
import { Button } from 'src/components/Button';
import { InputText } from 'src/components/InputText';
import { UseFormReturn } from 'src/hooks';
import { FormInputChangePassowordEmail } from '../../types';

interface ChangePasswordUIProps
  extends Pick<UseFormReturn, 'formData' | 'formErrors' | 'onChangeFormInput'> {
  onSubmit: (e: FormEvent) => void;
}

export const ChangePasswordCodeUI: React.FC<ChangePasswordUIProps> = ({
  formData,
  formErrors,
  onChangeFormInput,
  onSubmit,
}) => {
  return (
    <div className=" flex items-center justify-center bg-white  px-4">
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
          Esqueceu sua senha?
        </h2>

        <form onSubmit={onSubmit} className="space-y-4">
          <InputText
            name="email"
            label="Informe seu e-mail"
            placeholder="Digite o e-mail"
            value={formData[FormInputChangePassowordEmail.email]}
            onChange={(e) =>
              onChangeFormInput(FormInputChangePassowordEmail.email)(
                e.target.value
              )
            }
            error={formErrors.email && formErrors.email[0]}
            className=""
            inputClassName="w-full p-3 rounded-lg border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500"
          />

          <Button
            type="submit"
            title="Confirmar Código"
            buttonStyle="red"
            size="lg"
            className="w-full mt-4"
            disabled={formData[FormInputChangePassowordEmail.email] === ''}
          />
        </form>
      </div>
    </div>
  );
};
